"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Home = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Home = function Home(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M27.23,9.75,15.23.42a2,2,0,0,0-2.46,0L.77,9.75A2,2,0,0,0,0,11.33V26a4.68,4.68,0,0,0,4.67,4.67H23.33A4.68,4.68,0,0,0,28,26V11.33A2,2,0,0,0,27.23,9.75ZM16,26.67H12V17.33h4ZM24,26a.67.67,0,0,1-.67.67H20V15.33a2,2,0,0,0-2-2H10a2,2,0,0,0-2,2V26.67H4.67A.67.67,0,0,1,4,26V12.31L14,4.53l10,7.78Z"
  }));
};

exports.Home = Home;